<template>
<!--	@click="onClick"-->
	<a
		class="ar-button"
		rel="ar"

		:href="link"
	>
		<!-- Here MUST be single child  https://webkit.org/blog/8421/viewing-augmented-reality-assets-in-safari-for-ios/ -->
		<!-- <span class="visually-hidden">View in AR</span>-->
		<img class="fake-image" src="@/assets/logo.png" alt="">
	</a>
</template>

<script>

import { ref, computed } from 'vue';
import useCustomizer from '@/composables/Customizer';

const isIOS = () => [
	'iPad Simulator',
	'iPhone Simulator',
	'iPod Simulator',
	'iPad',
	'iPhone',
	'iPod',
].includes(navigator.platform)
		// iPad on iOS 13 detection
		|| (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

const isAndroid = () => {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	return (userAgent.match(/Android/i));

};

export default {
	name: 'ARBtn',
	setup(props, { emit }) {
		const {
			currentStep,
			objectsState,
			loadingState,
		} = useCustomizer();

		const currentLinksToModels = computed(() => {
			const currentObject = objectsState.value.find((object) => object.id === currentStep.value.target);
			return currentObject.arModels;
		});

		const link = ref(null);
		const download = isIOS() ? 'polaroid.usdz' : undefined;

		// onMounted(() => {
		if (isIOS() || isAndroid()) {
			if (isIOS()) {
				// link.value;
				link.value = currentLinksToModels.value.ios;
			}

			if (isAndroid()) {
				link.value = currentLinksToModels.value.android;
			}
		}
		// });

		const onClick = () => {
			if (isIOS() || isAndroid()) {
				loadingState.value = {
					type: 'loading',
				};

				setTimeout(() => {
					loadingState.value = {
						type: 'loaded',
					};
				}, 10000);

				return;
			}

			link.value = undefined;

			emit('show-ar-pop-up');
		};

		return {
			onClick,
			link,
			download,
		};
	},
};
</script>

<style lang="sass" scoped>
@import "@/assets/styles.sass"

.ar-button
	width: 50px
	height: 50px
	position: relative
	display: inline-flex
	align-items: center
	justify-content: center
	border-radius: 50%
	background: #000000 url('@/assets/ar-logo.svg') no-repeat center
	background-size: 35px
	border: none
	cursor: pointer
	color: #000000
	transition: color .25s ease, background-color .25s ease

	@media (max-width: 650px)
		width: 42px
		height: 42px

	&:active
		background-color: #333333

	&::before
		content: ''
		z-index: 0
		position: absolute
		width: 100%
		height: 100%
		border-radius: inherit
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08)

	& > svg
		display: block

.fake-image
	display: none

</style>
